import { SearchResult } from "@/api";

import { CourseSearchResult } from "../../../views/explore/courseView";

export function toCourseResult(goal: string, results: SearchResult[]): CourseSearchResult {
  return {
    type: "course",
    title: "Made for you",
    description: goal,
    imageUrl: "/static/images/made-for-you/tile-bg.png",
    entities: results.flatMap(({ entities }) => entities || []),
  };
}
